import Vue from 'vue';
import Index from './Index/Index.vue';

const Components = {
  Index
};

Object.keys(Components).forEach(name => {
  Vue.component(name, Components[name]);
});

export default Components;
